/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/naming-convention */
export const currentColor = {
  transparent: 'transparent',
  whiteFaded: 'rgba(255, 255, 255, 0.32)',
  white: '#FFFFFF',
  main: '#2455B0',
  green: '#00BA6C',
  text: '#40464E',
  secondaryText: '#778092',
  mainFaded: 'rgba(239, 243, 249, 1)',
  grey: '#AAB4C8',
  softGrey: '#F7F9FA',
  softGrey2: '#2455b014',
  softGrey3: '#BFC9D9',
  softGrey4: '#D6DFEB',
  softGrey5: '#E9E9E9',
  softGrey6: '#E0E0E0',
  blackFaded: 'rgba(0, 0, 0, 0.5)',
  red: '#EC465C',
  redFaded: 'rgba(236, 70, 92, .1)',
  tableHead: '#FAFCFE',
  body: '#F3F6FA',
  grey70: '#8D96AA',
  textSoft: '#525A67',
  border: '#e4eaf3',
  mainSoft: '#76cd9f',
  orange: '#FA591D',
  orange1: '#FEF2E6',
  orange2: '#F97B06',
  yellow: '#FFF0B3',
  pink: '#FF5C84',
  pinkFaded: '#FFEAEF',
  grass: '#03AC0E',
  grassFaded: '#D6FFDE',
  alertBg: '#FFE163',
  yellowFaded: '#FFFAE6',
  yellowAlert: '#FFF1BA',
  black: '#333333',
  pureBlack: 'black',
  blueFaded: 'rgba(36, 85, 176, 0.1)',
  blue: '#2455B0',
  maroon: '#CC4339',
  redTag: '#DD342F',
  blueTag: '#246EE5',
  yellowTag: '#FFBB0C',
  green100: '#098A4E',
  greySoft: '#6D7588',
  bgIcon: '#F3F4F5',
  blueSoft: '#0479B9',
  blueTosca: '#C5FCFF',
  mercuryGrey: '#F3F4F5',
  mainV2: '#246EE5',
  textV2: '#212121',
  greenLegend: '#2ABF6C',
  yellowLegend: '#FFE600',
  redLegend: '#FF0021',
  tableBlue: '#F4F9FF',
  green1: '#E7F5E6',
  green5: '#42B139',
  green6: '#139D07',
  red6: '#E25450',
  neutralGrey: '#F0F2F5',
  blackToast: '#3E3E3E',
  grey64: '#646464',
  greyA6: '#A6A6A6',
  greyE9: '#E9E9E9',
  spaceBlack: '#5C5C5C',
  greyD3: '#D3D3D3',
  warning: '#E67800',
  success: '#00AA5B',
  pending: '#F94D63',
  inprogress: '#FFBB0C',
  done: '#00AA5B',
  lightOrange: '#FFF3E6',
  greenTag: '#E6F7EF',
  purpleTag: '#F0EDF8',
  purpleText: '#6847BB',
  disabled: 'rgba(0, 0, 0, 0.26)',
  skpTableHeadBg: '#78909C',
  bgLightBlue: '#E9F1FC',
  redOutline: '#FF1E00',
  softRed: '#e65a67',
  lightBlue: '#E9F1FC',
  bgDisabled: '#FAFAFA',
  bgOrange: '#FF8500',
  yellowError: '#F08227',
  redPriority: '#E61B00',
  primaryGalaxy13: '#123773',
  textDarkGreen: '#00331B',
  textRed: '#641F28',
  borderLightBlue: '#D3E2FA',
  borderLightOrange: '#FFDAB3',
  borderLightGreen: '#B3E6CE',
  borderLightRed: '#FDCAD0',
  iconRed: '#E04559',
  bgLightRed: '#FEEDEF',
  textOrange: '#663500',
  textGreen: '#004424',
  bgLightOrange: '#E9F1FC',
  iconDarkBlue: '#2063CE',
  iconGreen: '#009952',
  iconEnabledLow: '#B5BBC5',
  greyD9: '#D9D9D9',
  redDark: '#B31500',
  greenDark: '#007740',
  textGold: '#997007',
  textDarkBlue: '#0E2C5C',
  bgLightBlueTag: '#A7C5F5',
  bgLightPurple: '#E1DAF1',
  primaryGalaxy5: '#92B7F2',
  bgLightYellow: '#FFF8E7',
  roundBorder: '#DCDCDC',
  textError: '#d32f2f',
  borderPrimary: '#BDD4F7',
  lightOrangeBorder: '#FFE7CC',
  lightPurpleBorder: '#D2C8EB',
  rowHoverBg: '#F3F3F3',
}

export const red = {
  red1: '#fdeaea',
  red2: '#fabfbd',
  red3: '#f7a09d',
  red4: '#f47571',
  red5: '#f15a55',
  red6: '#ee312b',
  red7: '#d92d27',
  red8: '#a9231f',
  red9: '#831b18',
  red900: '#641512',
}

export const blue = {
  blue1: '#eaf1fd',
  blue2: '#bdd4fa',
  blue3: '#9dc0f7',
  blue4: '#71a3f4',
  blue5: '#5591f1',
  blue6: '#2b75ee',
  blue7: '#276ad9',
  blue8: '#1f53a9',
  blue9: '#184083',
  blue900: '#123164',
  blue10: '#246EE5',
}

export const grey = {
  grey0: '#ffffff',
  grey1: '#eeeeee',
  grey2: '#cccccc',
  grey3: '#b3b3b3',
  grey4: '#909090',
  grey5: '#7a7a7a',
  grey6: '#595959',
  grey7: '#515151',
  grey8: '#252525',
  grey9: '#0e0e0e',
  grey10: '#d1d1d1',
}

export const green = {
  green50: '#e7f5e6',
  green100: '#b6e1b2',
  green200: '#92d28d',
  green300: '#61bd59',
  green400: '#42b139',
  green500: '#139d07',
  green600: '#118f06',
  green700: '#0d6f05',
  green800: '#0a5604',
  green900: '#084203',
}

export const orange = {
  orange50: '#fef2e6',
  orange100: '#fdd6b2',
  orange200: '#fcc28c',
  orange300: '#fba758',
  orange400: '#fa9538',
  orange500: '#f97b06',
  orange600: '#e37005',
  orange700: '#b15704',
  orange800: '#894403',
  orange900: '#693403',
}

const colors = {
  ...currentColor,
  ...red,
  ...blue,
  ...grey,
  ...green,
  ...orange,
}

export const dsColor = {
  galaxy: {
    'galaxy-15': '#0B2145',
    'galaxy-14': '#0E2C5C',
    'galaxy-13': '#123773',
    'galaxy-12': '#164289',
    'galaxy-11': '#194DA0',
    'galaxy-10': '#1D58B7',
    'galaxy-9': '#2063CE',
    'galaxy-8': '#246EE5',
    'galaxy-7': '#669AED',
    'galaxy-6': '#7CA8EF',
    'galaxy-5': '#92B7F2',
    'galaxy-4': '#A7C5F5',
    'galaxy-3': '#BDD4F7',
    'galaxy-2': '#D3E2FA',
    'galaxy-1': '#E9F1FC',
    'galaxy-0': '#F3F6FA',
  },
  nebula: {
    'nebula-15': '#4C0900',
    'nebula-14': '#660C00',
    'nebula-13': '#800F00',
    'nebula-12': '#991200',
    'nebula-11': '#B31500',
    'nebula-10': '#CC1800',
    'nebula-9': '#E61B00',
    'nebula-8': '#FF1E00',
    'nebula-7': '#FF624D',
    'nebula-6': '#FF7866',
    'nebula-5': '#FF8F80',
    'nebula-4': '#FFA599',
    'nebula-3': '#FFBCB3',
    'nebula-2': '#FFD2CC',
    'nebula-1': '#FFE9E6',
  },
  desktop: {
    mutliSelection: {
      text: '#a6a6a6',
      bgColor: '#e9e9e9',
      icon: '#a6a6a6',
      stroke: '#d3d3d3',
    },
  },
  tagging: {
    text: '#646464',
    bgColor: '#e9e9e9',
  },
  neutral: {
    'neutral-12': '#070707',
    'neutral-11': '#141414',
    'neutral-10': '#212121',
    'neutral-9': '#373737',
    'neutral-8': '#646464',
    'neutral-7': '#7A7A7A',
    'neutral-6': '#909090',
    'neutral-5': '#a6a6a6',
    'neutral-4': '#bcbcbc',
    'neutral-3': '#d3d3d3',
    'neutral-2': '#e9e9e9',
    'neutral-1': '#ffffff',
    special: '#fafafa',
  },
  sys: {
    green: {
      'gr-15': '#00331B',
      'gr-14': '#004424',
      'gr-13': '#00552E',
      'gr-12': '#006637',
      'gr-11': '#007740',
      'gr-10': '#008849',
      'gr-9': '#009952',
      'gr-8': '#00AA5B',
      'gr-7': '#4DC48C',
      'gr-6': '#66CC9D',
      'gr-5': '#80D5AD',
      'gr-4': '#99DDBD',
      'gr-3': '#B3E6CE',
      'gr-2': '#CCEEDE',
      'gr-1': '#E6F7EF',
    },
    orange: {
      'or-15': '#4C2800',
      'or-14': '#663500',
      'or-13': '#804300',
      'or-12': '#995000',
      'or-11': '#B35D00',
      'or-10': '#CC6A00',
      'or-9': '#E67800',
      'or-8': '#FF8500',
      'or-7': '#FFAA4D',
      'or-6': '#FFB666',
      'or-5': '#FFC280',
      'or-4': '#FFCE99',
      'or-3': '#FFDAB3',
      'or-2': '#FFE7CC',
      'or-1': '#FFF3E6',
    },
    red: {
      'red-15': '#4B171E',
      'red-14': '#641F28',
      'red-13': '#7D2732',
      'red-12': '#952E3B',
      'red-11': '#AE3645',
      'rd-10': '#C73E4F',
      'rd-9': '#E04559',
      'rd-8': '#F94D63',
      'rd-7': '#FB8292',
      'rd-6': '#FB94A1',
      'rd-5': '#FCA6B1',
      'rd-4': '#FDB8C1',
      'rd-3': '#FDCAD0',
      'rd-2': '#FEDBE0',
      'rd-1': '#FEEDEF',
    },
  },
  btnPrimary: {
    disable: '#e9e9e9',
    default: '#246EE5',
    hover: '#194DA0',
    selected: '#123773',
    outline: '#246EE5',
    outlineHover: '#BDD4F7',
    outlineSelected: '#92B7F2',
    outlineDisable: '#d3d3d3',
  },
  btnSecondary: {
    disable: '#e9e9e9',
    default: '#FF1E00',
    hover: '#B31500',
    selected: '#800F00',
    outline: '#FF1E00',
    outlineHover: '#FFBCB3',
    outlineSelected: '#FF8F80',
    outlineDisable: '#d3d3d3',
  },
  bgColor: {
    light: '#ffffff',
    disable: '#fafafa',
    disableD: '#e9e9e9',
    dark: '#212121',
    darker: '#373737',
    lightPrimary: '#E9F1FC',
    sLightPrimary: '#A7C5F5',
    primary: '#246EE5',
    primaryDark: '#0B2145',
    secondary: '#E61B00',
    lightSecondary: '#FFE9E6',
    lightGreen: '#E6F7EF',
    lightRed: '#FEEDEF',
    lightOrange: '#FFF3E6',
    lightBlue: '#E9F1FC',
    lightGrey: '#e9e9e9',
    lightYellow: '#FFF8E7',
    lightCyan: '#EEFBFD',
    lightPurple: '#F0EDF8',
    lightMagenta: '#F6E6FC',
    green: '#00AA5B',
    greenDark: '#007740',
    red: '#F94D63',
    redDark: '#AE3645',
    orange: '#FF8500',
    orangeDark: '#B35D00',
    blue: '#2063CE',
    blueDark: '#194DA0',
    grey: '#909090',
    sLightGrey: '#bcbcbc',
    greyDark: '#7A7A7A',
    yellow: '#FFBB0C',
    yellowDark: '#B38308',
    cyan: '#58D9E6',
    cyanDark: '#3E98A1',
    purple: '#6847bb',
    purpleDark: '#493283',
    magenta: '#A500E0',
    magentaBlack: '#73009D',
    vlightPrimary: '#F3F6FA',
  },
  textColor: {
    primaryDark: '#212121',
    secondaryDark: '#646464',
    primaryLight: '#ffffff',
    secondaryLight: '#d3d3d3',
    placeholder: '#a6a6a6',
    disable: '#a6a6a6',
    btnDisable: '#BDD4F7',
    link: '#246EE5',
    linkHover: '#194DA0',
    linkSelected: '#123773',
    error: '#F94D63',
    warning: '#E67800',
    sucess: '#00AA5B',
    linkSecondary: '#E61B00',
    yellow: '#FFBB0C',
    cyan: '#4FC3CF',
    purple: '#6847bb',
    magenta: '#A500E0',
  },
  iconColor: {
    default: '#646464',
    defaultAlt: '#909090',
    dark: '#212121',
    placeholder: '#e9e9e9',
    disable: '#a6a6a6',
    light: '#ffffff',
    red: '#F94D63',
    green: '#00AA5B',
    orange: '#FF8500',
    primary: '#246EE5',
    primaryHover: '#194DA0',
    primarySelected: '#123773',
    yellow: '#FFBB0C',
    cyan: '#58D9E6',
    purple: '#6847bb',
    magenta: '#A500E0',
    secondary: '#FF1E00',
  },
  strokeColor: {
    default: '#d3d3d3',
    subtle: '#e9e9e9',
    disable: '#d3d3d3',
    light: '#ffffff',
    active: '#246EE5',
    error: '#FF1E00',
    sucess: '#00AA5B',
    filled: '#646464',
    warning: '#FF8500',
    dark: '#373737',
  },
  qd: {
    yellow: {
      'yl-1': '#FFF8E7',
      'yl-2': '#FFF1CE',
      'yl-3': '#FFEBB6',
      'yl-4': '#FFE49E',
      'yl-5': '#FFDD86',
      'yl-6': '#FFD66D',
      'yl-7': '#FFCF55',
      'yl-8': '#FFBB0C',
      'yl-9': '#E6A80B',
      'yl-10': '#CC960A',
      'yl-11': '#B38308',
      'yl-12': '#997007',
      'yl-13': '#805E06',
      'yl-14': '#664B05',
      'yl-15': '#4C3804',
    },
    cyan: {
      'cy-1': '#EEFBFD',
      'cy-2': '#DEF7FA',
      'cy-3': '#CDF4F8',
      'cy-4': '#BCF0F5',
      'cy-5': '#ACECF3',
      'cy-6': '#9BE8F0',
      'cy-7': '#8AE4EE',
      'cy-8': '#58D9E6',
      'cy-9': '#4FC3CF',
      'cy-10': '#46AEB8',
      'cy-11': '#3E98A1',
      'cy-12': '#35828A',
      'cy-13': '#2C6D73',
      'cy-14': '#23575C',
      'cy-15': '#1A4145',
    },
    purple: {
      'pr-1': '#F0EDF8',
      'pr-2': '#E1DAF1',
      'pr-3': '#D2C8EB',
      'pr-4': '#C3B5E4',
      'pr-5': '#B4A3DD',
      'pr-6': '#A491D6',
      'pr-7': '#957ecf',
      'pr-8': '#6847bb',
      'pr-9': '#5E40A8',
      'pr-10': '#533996',
      'pu-11': '#493283',
      'pu-12': '#3E2B70',
      'pu-13': '#34245E',
      'pu-14': '#2A1C4B',
      'pu-15': '#1F1538',
    },
    magenta: {
      'mg-1': '#F6E6FC',
      'mg-2': '#EDCCF9',
      'mg-3': '#E4B3F6',
      'mg-4': '#DB99F3',
      'mg-5': '#D280F0',
      'mg-6': '#C966EC',
      'pr-7': '#C04DE9',
      'mg-8': '#A500E0',
      'mg-9': '#9500CA',
      'mg-10': '#8400B3',
      'mg-11': '#73009D',
      'mg-12': '#630086',
      'mg-13': '#630086',
      'mg-14': '#42005A',
      'mg-15': '#310043',
    },
  },
  btnNeutral: {
    default: '#e9e9e9',
    hover: '#d3d3d3',
    selected: '#bcbcbc',
    disable: '#bcbcbc',
    outline: '#d3d3d3',
    outlineHover: '#e9e9e9',
    outlineSelected: '#d3d3d3',
    outlineDisable: '#d3d3d3',
  },
  gradient: {
    bgCustom: {
      topSection:
        'linear-gradient(242deg, #b92421 0%, #040546 43.13%, #040546 71.79%, #0c2871 100%)',
      slightYellow: 'linear-gradient(165.08deg, #FFC01F -26.72%, #FFE7A8 90.77%)',
      slightBlue: 'linear-gradient(260deg, #a9bfe6 5.14%, #d9d9d900 100%)',
      blue: 'linear-gradient(268.98deg, #1553B6 0%, #246EE5 100%)',
    },
    bgRegular: {
      lightPrimary: 'linear-gradient(0deg, #e9f1fc 0%, #e9f1fc00 100%)',
      lightSecondary: 'linear-gradient(0deg, #ffe9e6 0%, #ffe9e600 100%)',
      lightGreen: 'linear-gradient(0deg, #e6f7ef 0%, #e6f7ef00 100%)',
      lightOrange: 'linear-gradient(0deg, #fff3e6 0%, #fff3e600 100%)',
      lightRed: 'linear-gradient(0deg, #feedef 0%, #fff3e600 100%, #feedef00 100%)',
      lightYellow: 'linear-gradient(0deg, #fff8e7 0%, #fff3e600 100%, #fff8e700 100%)',
      lightCyan: 'linear-gradient(0deg, #eefbfd 0%, #fff3e600 100%, #eefbfd 100%)',
      lightPurple: 'linear-gradient(0deg, #f0edf8 0%, #fff3e600 100%, #f0edf800 100%)',
      lightMagenta: 'linear-gradient(0deg, #f6e6fc 0%, #fff3e600 100%, #f6e6fc00 100%)',
      slightlyPrimary: 'linear-gradient(260deg, #a7c5f5 5.14%, #ffffff00 100%)',
      slightlySecondary: 'linear-gradient(260deg, #ffa599 5.14%, #ffffff00 100%)',
      slightlyGreen: 'linear-gradient(260deg, #99ddbd 5.14%, #ffffff00 100%)',
      slightlyOrange: 'linear-gradient(260deg, #ffce99 5.14%, #ffffff00 100%)',
      slightlyRed: 'linear-gradient(260deg, #fdb8c1 5.14%, #ffffff00 100%)',
      slightlyYellow: 'linear-gradient(260deg, #ffe49e 5.14%, #ffffff00 100%)',
      slightlyCyan: 'linear-gradient(260deg, #bcf0f5 5.14%, #ffffff00 100%)',
      slightlyPurple: 'linear-gradient(260deg, #c3b5e4 5.14%, #ffffff00 100%)',
      slightlyMagenta: 'linear-gradient(260deg, #db99f3 5.14%, #ffffff00 100%)',
    },
    shimmer: {
      right: 'linear-gradient(90deg, #e9e9e9 0%, #e9e9e900 100%)',
      centre: 'linear-gradient(90deg, #e9e9e999 0%, #e9e9e900 50.69%, #e9e9e999 97.4%)',
      left: 'linear-gradient(90deg, #e9e9e900 0%, #e9e9e9 97.4%)',
    },
  },
}

export type ColorsType = typeof colors
export type DSColorType = typeof dsColor
export default colors

declare module '@mui/material/styles' {
  interface PaletteOptions {
    galaxy?: DSColorType['galaxy']
    nebula?: DSColorType['nebula']
    desktop?: DSColorType['desktop']
    tagging?: DSColorType['tagging']
    neutral?: DSColorType['neutral']
    sys?: DSColorType['sys']
    btnPrimary?: DSColorType['btnPrimary']
    btnSecondary?: DSColorType['btnSecondary']
    bgColor?: DSColorType['bgColor']
    textColor?: DSColorType['textColor']
    iconColor?: DSColorType['iconColor']
    strokeColor?: DSColorType['strokeColor']
    qd?: DSColorType['qd']
    btnNeutral?: DSColorType['btnNeutral']
    gradient?: DSColorType['gradient']
  }

  interface Palette {
    galaxy: DSColorType['galaxy']
    nebula: DSColorType['nebula']
    desktop: DSColorType['desktop']
    tagging: DSColorType['tagging']
    neutral: DSColorType['neutral']
    sys: DSColorType['sys']
    btnPrimary: DSColorType['btnPrimary']
    btnSecondary: DSColorType['btnSecondary']
    bgColor: DSColorType['bgColor']
    textColor: DSColorType['textColor']
    iconColor: DSColorType['iconColor']
    strokeColor: DSColorType['strokeColor']
    qd: DSColorType['qd']
    btnNeutral: DSColorType['btnNeutral']
    gradient: DSColorType['gradient']
  }
}

export type ColorKeyPrefixType =
  | 'galaxy.galaxy-15'
  | 'galaxy.galaxy-14'
  | 'galaxy.galaxy-13'
  | 'galaxy.galaxy-12'
  | 'galaxy.galaxy-11'
  | 'galaxy.galaxy-10'
  | 'galaxy.galaxy-9'
  | 'galaxy.galaxy-8'
  | 'galaxy.galaxy-7'
  | 'galaxy.galaxy-6'
  | 'galaxy.galaxy-5'
  | 'galaxy.galaxy-4'
  | 'galaxy.galaxy-3'
  | 'galaxy.galaxy-2'
  | 'galaxy.galaxy-1'
  | 'galaxy.galaxy-0'
  | 'nebula.nebula-15'
  | 'nebula.nebula-14'
  | 'nebula.nebula-13'
  | 'nebula.nebula-12'
  | 'nebula.nebula-11'
  | 'nebula.nebula-10'
  | 'nebula.nebula-9'
  | 'nebula.nebula-8'
  | 'nebula.nebula-7'
  | 'nebula.nebula-6'
  | 'nebula.nebula-5'
  | 'nebula.nebula-4'
  | 'nebula.nebula-3'
  | 'nebula.nebula-2'
  | 'nebula.nebula-1'
  | 'desktop.mutliSelection.text'
  | 'desktop.mutliSelection.bgColor'
  | 'desktop.mutliSelection.icon'
  | 'desktop.mutliSelection.stroke'
  | 'tagging.text'
  | 'tagging.bgColor'
  | 'neutral.neutral-12'
  | 'neutral.neutral-11'
  | 'neutral.neutral-10'
  | 'neutral.neutral-9'
  | 'neutral.neutral-8'
  | 'neutral.neutral-7'
  | 'neutral.neutral-6'
  | 'neutral.neutral-5'
  | 'neutral.neutral-4'
  | 'neutral.neutral-3'
  | 'neutral.neutral-2'
  | 'neutral.neutral-1'
  | 'neutral.special'
  | 'sys.green.gr-15'
  | 'sys.green.gr-14'
  | 'sys.green.gr-13'
  | 'sys.green.gr-12'
  | 'sys.green.gr-11'
  | 'sys.green.gr-10'
  | 'sys.green.gr-9'
  | 'sys.green.gr-8'
  | 'sys.green.gr-7'
  | 'sys.green.gr-6'
  | 'sys.green.gr-5'
  | 'sys.green.gr-4'
  | 'sys.green.gr-3'
  | 'sys.green.gr-2'
  | 'sys.green.gr-1'
  | 'sys.orange.or-15'
  | 'sys.orange.or-14'
  | 'sys.orange.or-13'
  | 'sys.orange.or-12'
  | 'sys.orange.or-11'
  | 'sys.orange.or-10'
  | 'sys.orange.or-9'
  | 'sys.orange.or-8'
  | 'sys.orange.or-7'
  | 'sys.orange.or-6'
  | 'sys.orange.or-5'
  | 'sys.orange.or-4'
  | 'sys.orange.or-3'
  | 'sys.orange.or-2'
  | 'sys.orange.or-1'
  | 'sys.red.red-15'
  | 'sys.red.red-14'
  | 'sys.red.red-13'
  | 'sys.red.red-12'
  | 'sys.red.red-11'
  | 'sys.red.rd-10'
  | 'sys.red.rd-9'
  | 'sys.red.rd-8'
  | 'sys.red.rd-7'
  | 'sys.red.rd-6'
  | 'sys.red.rd-5'
  | 'sys.red.rd-4'
  | 'sys.red.rd-3'
  | 'sys.red.rd-2'
  | 'sys.red.rd-1'
  | 'btnPrimary.disable'
  | 'btnPrimary.default'
  | 'btnPrimary.hover'
  | 'btnPrimary.selected'
  | 'btnPrimary.outline'
  | 'btnPrimary.outlineHover'
  | 'btnPrimary.outlineSelected'
  | 'btnPrimary.outlineDisable'
  | 'btnSecondary.disable'
  | 'btnSecondary.default'
  | 'btnSecondary.hover'
  | 'btnSecondary.selected'
  | 'btnSecondary.outline'
  | 'btnSecondary.outlineHover'
  | 'btnSecondary.outlineSelected'
  | 'btnSecondary.outlineDisable'
  | 'bgColor.light'
  | 'bgColor.disable'
  | 'bgColor.disableD'
  | 'bgColor.dark'
  | 'bgColor.darker'
  | 'bgColor.lightPrimary'
  | 'bgColor.sLightPrimary'
  | 'bgColor.primary'
  | 'bgColor.primaryDark'
  | 'bgColor.secondary'
  | 'bgColor.lightSecondary'
  | 'bgColor.lightGreen'
  | 'bgColor.lightRed'
  | 'bgColor.lightOrange'
  | 'bgColor.lightBlue'
  | 'bgColor.lightGrey'
  | 'bgColor.lightYellow'
  | 'bgColor.lightCyan'
  | 'bgColor.lightPurple'
  | 'bgColor.lightMagenta'
  | 'bgColor.green'
  | 'bgColor.greenDark'
  | 'bgColor.red'
  | 'bgColor.redDark'
  | 'bgColor.orange'
  | 'bgColor.orangeDark'
  | 'bgColor.blue'
  | 'bgColor.blueDark'
  | 'bgColor.grey'
  | 'bgColor.sLightGrey'
  | 'bgColor.greyDark'
  | 'bgColor.yellow'
  | 'bgColor.yellowDark'
  | 'bgColor.cyan'
  | 'bgColor.cyanDark'
  | 'bgColor.purple'
  | 'bgColor.purpleDark'
  | 'bgColor.magenta'
  | 'bgColor.magentaBlack'
  | 'bgColor.vlightPrimary'
  | 'textColor.primaryDark'
  | 'textColor.secondaryDark'
  | 'textColor.primaryLight'
  | 'textColor.secondaryLight'
  | 'textColor.placeholder'
  | 'textColor.disable'
  | 'textColor.btnDisable'
  | 'textColor.link'
  | 'textColor.linkHover'
  | 'textColor.linkSelected'
  | 'textColor.error'
  | 'textColor.warning'
  | 'textColor.sucess'
  | 'textColor.linkSecondary'
  | 'textColor.yellow'
  | 'textColor.cyan'
  | 'textColor.purple'
  | 'textColor.magenta'
  | 'iconColor.default'
  | 'iconColor.defaultAlt'
  | 'iconColor.dark'
  | 'iconColor.placeholder'
  | 'iconColor.disable'
  | 'iconColor.light'
  | 'iconColor.red'
  | 'iconColor.green'
  | 'iconColor.orange'
  | 'iconColor.primary'
  | 'iconColor.primaryHover'
  | 'iconColor.primarySelected'
  | 'iconColor.yellow'
  | 'iconColor.cyan'
  | 'iconColor.purple'
  | 'iconColor.magenta'
  | 'iconColor.secondary'
  | 'strokeColor.default'
  | 'strokeColor.subtle'
  | 'strokeColor.disable'
  | 'strokeColor.light'
  | 'strokeColor.active'
  | 'strokeColor.error'
  | 'strokeColor.sucess'
  | 'strokeColor.filled'
  | 'strokeColor.warning'
  | 'strokeColor.dark'
  | 'qd.yellow.yl-1'
  | 'qd.yellow.yl-2'
  | 'qd.yellow.yl-3'
  | 'qd.yellow.yl-4'
  | 'qd.yellow.yl-5'
  | 'qd.yellow.yl-6'
  | 'qd.yellow.yl-7'
  | 'qd.yellow.yl-8'
  | 'qd.yellow.yl-9'
  | 'qd.yellow.yl-10'
  | 'qd.yellow.yl-11'
  | 'qd.yellow.yl-12'
  | 'qd.yellow.yl-13'
  | 'qd.yellow.yl-14'
  | 'qd.yellow.yl-15'
  | 'qd.cyan.cy-1'
  | 'qd.cyan.cy-2'
  | 'qd.cyan.cy-3'
  | 'qd.cyan.cy-4'
  | 'qd.cyan.cy-5'
  | 'qd.cyan.cy-6'
  | 'qd.cyan.cy-7'
  | 'qd.cyan.cy-8'
  | 'qd.cyan.cy-9'
  | 'qd.cyan.cy-10'
  | 'qd.cyan.cy-11'
  | 'qd.cyan.cy-12'
  | 'qd.cyan.cy-13'
  | 'qd.cyan.cy-14'
  | 'qd.cyan.cy-15'
  | 'qd.purple.pr-1'
  | 'qd.purple.pr-2'
  | 'qd.purple.pr-3'
  | 'qd.purple.pr-4'
  | 'qd.purple.pr-5'
  | 'qd.purple.pr-6'
  | 'qd.purple.pr-7'
  | 'qd.purple.pr-8'
  | 'qd.purple.pr-9'
  | 'qd.purple.pr-10'
  | 'qd.purple.pu-11'
  | 'qd.purple.pu-12'
  | 'qd.purple.pu-13'
  | 'qd.purple.pu-14'
  | 'qd.purple.pu-15'
  | 'qd.magenta.mg-1'
  | 'qd.magenta.mg-2'
  | 'qd.magenta.mg-3'
  | 'qd.magenta.mg-4'
  | 'qd.magenta.mg-5'
  | 'qd.magenta.mg-6'
  | 'qd.magenta.pr-7'
  | 'qd.magenta.mg-8'
  | 'qd.magenta.mg-9'
  | 'qd.magenta.mg-10'
  | 'qd.magenta.mg-11'
  | 'qd.magenta.mg-12'
  | 'qd.magenta.mg-13'
  | 'qd.magenta.mg-14'
  | 'qd.magenta.mg-15'
  | 'btnNeutral.default'
  | 'btnNeutral.hover'
  | 'btnNeutral.selected'
  | 'btnNeutral.disable'
  | 'btnNeutral.outline'
  | 'btnNeutral.outlineHover'
  | 'btnNeutral.outlineSelected'
  | 'btnNeutral.outlineDisable'
  | 'gradient.bgCustom.topSection'
  | 'gradient.bgCustom.slightYellow'
  | 'gradient.bgCustom.slightBlue'
  | 'gradient.bgCustom.blue'
  | 'gradient.bgRegular.lightPrimary'
  | 'gradient.bgRegular.lightSecondary'
  | 'gradient.bgRegular.lightGreen'
  | 'gradient.bgRegular.lightOrange'
  | 'gradient.bgRegular.lightRed'
  | 'gradient.bgRegular.lightYellow'
  | 'gradient.bgRegular.lightCyan'
  | 'gradient.bgRegular.lightPurple'
  | 'gradient.bgRegular.lightMagenta'
  | 'gradient.bgRegular.slightlyPrimary'
  | 'gradient.bgRegular.slightlySecondary'
  | 'gradient.bgRegular.slightlyGreen'
  | 'gradient.bgRegular.slightlyOrange'
  | 'gradient.bgRegular.slightlyRed'
  | 'gradient.bgRegular.slightlyYellow'
  | 'gradient.bgRegular.slightlyCyan'
  | 'gradient.bgRegular.slightlyPurple'
  | 'gradient.bgRegular.slightlyMagenta'
  | 'gradient.shimmer.right'
  | 'gradient.shimmer.centre'
  | 'gradient.shimmer.left'
